import { LEGAL_DOCUMENTS, LEGAL_DOCUMENT_ORDER } from "../legal/legalContent";

// Settings "Legal" section (L0-U13, ADR 0028 D4). A tidy in-app home for the
// three trust documents, complementing the always-visible shell footer. Each row
// links the public top-level route (/terms, /privacy, /disclaimer) in a new tab;
// the copy itself lives in legalContent.tsx (the single source for titles +
// summaries), so this section stays in lockstep without duplicating text.
export function LegalSection() {
  return (
    <section aria-labelledby="legal-heading" className="space-y-6">
      <header>
        <h2
          id="legal-heading"
          className="font-display text-xl font-medium tracking-tight text-on-surface"
        >
          Legal
        </h2>
        <p className="mt-1 text-sm text-on-surface-variant">
          The documents that govern your use of WickScope.
        </p>
      </header>

      <div className="space-y-4">
        {LEGAL_DOCUMENT_ORDER.map((key) => {
          const doc = LEGAL_DOCUMENTS[key];
          return (
            <div
              key={doc.key}
              className="flex flex-wrap items-center justify-between gap-3 rounded-card border border-outline-variant bg-surface-container p-4"
            >
              <div className="min-w-0">
                <p className="font-medium text-on-surface">{doc.title}</p>
                <p className="mt-0.5 text-sm text-on-surface-variant">{doc.summary}</p>
              </div>
              <a
                href={doc.path}
                target="_blank"
                rel="noreferrer"
                className="text-sm font-medium text-primary underline"
              >
                Read
              </a>
            </div>
          );
        })}
      </div>
    </section>
  );
}
